import { IIconBase } from '..'

const circleIcon = ({
  color = '#000000',
  height = 24,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='lucide lucide-circle-icon lucide-circle'
    >
      <circle cx='12' cy='12' r='10' />
    </svg>
  )
}

export default circleIcon
